import i18n from 'locales/i18next';

export const formatNumber = (number: number, digitsAfterDecimal = 2, format = i18n.language) => {
  const options = { minimumFractionDigits: digitsAfterDecimal };
  const formattedNumber = Number(number?.toFixed(digitsAfterDecimal)) || 0;
  return formattedNumber.toLocaleString(format, options);
};

export default formatNumber;
